export default __webpack_public_path__ + "static/Calibre-Regular-98526589fa32315c552129869e08427e.woff";